import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

const PublicContext = React.createContext(false);

export const PublicProvider = PublicContext.Provider;

export const PublicConsumer = PublicContext.Consumer;

export const PublicApp = withRouter(({ children, location }) => {
    const [isPublicMode] = useState(location.pathname.startsWith('/public'));

    return (
        <PublicProvider value={isPublicMode}>
            {children}
        </PublicProvider>
    );
});

export default PublicContext;
